import * as yup from 'yup'

const UpdateProviderSchema = yup.object({
    provider_id: yup.string().required(),
    zone_id: yup.string().required(),
})

export default UpdateProviderSchema
